import { DefaultService } from '@/services/DefaultService';

export default class ApiEntidadeService extends DefaultService {

    constructor(http, router, env) {
        super(http, router, env)
    }

    findAllCombo(limit = 1000, ...param) {
        return this._http.get(encodeURI(`${this._env}/apientidade/findallcombo.json?limit=${limit}&param=${param}`), this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }
}